var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart-footer"},[_c('div',[_vm._v(" 商品数: "),_c('span',[_vm._v(_vm._s(_vm.totalCount))]),_vm._v(" | 折扣: "),_c('span',[_vm._v("¥"+_vm._s(_vm.totalDiscount.toFixed(2)))])]),_c('div',{staticClass:"total-display"},[_vm._v("¥ "+_vm._s(_vm.mainTotal.toFixed(2)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }